<div style="text-align: center;background-color: blue;color: white;padding: 10px;display: flex;justify-content: space-between;align-items: center;margin: -20px -20px 20px -20px;">
    <span>{{data.title}}</span>
    <button (click)="onClose()" style="background: none;border: none;color: white;font-size: 20px;cursor: pointer;">
        <i class="fas fa-times"></i>
    </button>
</div>
<table>
    <tr>
        <th style="padding-left: 10px !important;">Lead Status Name : </th>
        <th>
            <input type="text" [(ngModel)]="data.model.statusName" name="statusName" />
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">Color Scheme : </th>
        <th>
            <select [(ngModel)]="data.model.colorScheme" name="colorScheme">
                <option value="0">Select</option>
                <option value="Red">Red</option>
                <option value="Blue">Blue</option>
                <option value="Black">Black</option>
                <option value="Yellow">Yellow</option>
                <option value="Beige">Beige</option>
                <option value="Brown">Brown</option>
                <option value="Cyan">Cyan</option>
                <option value="Orange">Orange</option>
                <option value="Magneta">Magneta</option>
                <option value="Pink">Pink</option>
                <option value="Indigo">Indigo</option>
                <option value="Ivory">Ivory</option>
                <option value="Khaki">Khaki</option>
                <option value="Gray">Gray</option>
            </select>
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">Followup Required: </th>
        <th>
            <select [(ngModel)]="data.model.followupRequired" name="followupRequired">
                <option value="0">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
            </select>
        </th>
    </tr>
</table>
<br />
<button class="btn btn-sm btn-primary" (click)="onSave();" style="float: inline-end;">
    <i class="fas fa-plus"></i> Save
</button>